import './legacy/index.css';

import * as React from 'react';
import { render } from 'react-dom';
import * as cianMetrics from '@cian/metrics';

import { IFiltersProps } from './components/filters/filters';
import { IFiltersWithWrapperProps } from './components/filters/filters_with_wrapper';
import { INonBuildingWelcomeProps } from './components/non_building_welcome/non_building_welcome';

function loadComponents(): Promise<{[key: string]: React.ComponentClass<any>}> {
  return new Promise((resolve, reject) => {
    require.ensure([
      './components/login_form/login_form',
      './components/filters/filters',
      './components/filters/filters_with_wrapper',
      './components/app_sms_form/app_sms_form',
      './components/non_building_welcome/non_building_welcome',
    ], () => {
      resolve({
        LoginForm: require('./components/login_form/login_form').default,
        Filters: require('./components/filters/filters').default,
        FiltersWithWrapper: require('./components/filters/filters_with_wrapper').default,
        AppSmsForm: require('./components/app_sms_form/app_sms_form').default,
        NonBuildingWelcome: require('./components/non_building_welcome/non_building_welcome').default,
      });
    });
  });
}

export default function initMainPage() {
  let rendered = false;
  function collectMetrics() {
    if (rendered) return;

    if (process.env['ENABLE_METRICS']) {
      cianMetrics.add('applicationStart');
      cianMetrics.waitForAllBrowserMetrics(() => {
        const metrics = cianMetrics.collect('mainvert');
        if (process.env['BUILD_NAME']) {
          metrics.push({
            name: 'versions.mainvert.' + process.env['BUILD_NAME'].toLowerCase(),
            type: 'counter',
            value: 1,
          });
        }
        cianMetrics.send(metrics);
      });
    }

    rendered = true;
  }

  (window as any).renderLoginForm = (element: Element) => {
    loadComponents()
      .then(({ LoginForm }) => {
        render(<LoginForm />, element);
      });
  };
  (window as any).renderFilters = (element: Element, props: IFiltersProps) => {
    loadComponents()
      .then(({ Filters }) => {
        render(<Filters {...props} />, element, collectMetrics);
      });
  };
  (window as any).renderFiltersWithWrapper = (element: Element, props: IFiltersWithWrapperProps) => {
    loadComponents()
      .then(({ FiltersWithWrapper }) => {
        render(<FiltersWithWrapper {...props} />, element, collectMetrics);
      });
  };
  (window as any).renderAppSmsForm = (element: Element) => {
    loadComponents()
      .then(({ AppSmsForm }) => {
        render(<AppSmsForm />, element);
      });
  };
  (window as any).renderNonBuildingWelcome = (element: Element, props: INonBuildingWelcomeProps) => {
    loadComponents()
      .then(({ NonBuildingWelcome }) => {
        render(<NonBuildingWelcome {...props} />, element);
      });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/mainpage/index.tsx